import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 字典列表
  dictItemList(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dictItem/list?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 字典更新
  dictItemUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dictItem/update`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    });
  },
  // 字典详情
  dictItemDetails(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dictItem/details?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 字典新增
  dictItemAdd(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dictItem/add`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    });
  },
  // 字典删除
  dictItemDelete(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dictItem/delete?${parameterChange(data)}`,
      method: 'delete',
    });
  },
};
